import React from 'react';
import {Icon} from '@iconify/react';
import './iconButton.scss';

interface IconButtonProps {
    icon: string | JSX.Element;
    iconSize?: string;
    iconColor?: string;
    label?: string;
    indicatorValue?: number;
    onClick?: () => void;
    disabled?: boolean;
    horizontal?: boolean;
    dataCy?: string;
}

function IconButton({
    icon,
    iconSize,
    iconColor,
    indicatorValue,
    onClick,
    disabled,
    label,
    horizontal,
    dataCy,
}: IconButtonProps): JSX.Element {
    const trimmedIndicatorValue = indicatorValue && indicatorValue > 99 ? '99+' : indicatorValue;

    return (
        <button
            type="button"
            className={`c-iconButton ${!label ? 'c-iconButton--noLabel' : ''} ${horizontal ? 'c-iconButton--horizontal' : ''}`}
            onClick={onClick}
            disabled={disabled}
            aria-label={label}
            data-testid="iconButton"
            data-cy={dataCy}
        >
            <div className="c-iconButton__icon">
                {typeof icon === 'string' ? <Icon icon={icon} style={{fontSize: iconSize, color: iconColor}} /> : icon}
            </div>
            {label && <div className="c-iconButton__label">{label}</div>}
            {indicatorValue !== undefined && <span className="c-iconButton__indicator">{trimmedIndicatorValue}</span>}
        </button>
    );
}

export default IconButton;
